
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5q8CD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("jHYvL")).PlanSidebar);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $jHYvL = parcelRequire("jHYvL");

});
parcelRegister("jHYvL", function(module, exports) {

$parcel$export(module.exports, "PlanSidebar", () => $56ff59a08eefea73$export$c2ab800d01d9eb09);

var $5uXOq = parcelRequire("5uXOq");

var $1UEDB = parcelRequire("1UEDB");

var $fpoBX = parcelRequire("fpoBX");

var $lGo7j = parcelRequire("lGo7j");

var $eaZHI = parcelRequire("eaZHI");

var $9grVM = parcelRequire("9grVM");
const $56ff59a08eefea73$export$c2ab800d01d9eb09 = ()=>{
    const { loading: loading, data: data } = (0, $1UEDB.usePlan)();
    const theme = (0, $9grVM.useTheme)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, theme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpoBX.SidebarThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaZHI.Menu), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaZHI.Menu), null));
};
var $56ff59a08eefea73$export$2e2bcd8739ae039 = $56ff59a08eefea73$export$c2ab800d01d9eb09;

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("eaZHI", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $31a96ee8c0d32b5a$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6puUq = parcelRequire("6puUq");

var $cNW3X = parcelRequire("cNW3X");

var $8GFeY = parcelRequire("8GFeY");

var $aqJO7 = parcelRequire("aqJO7");

var $2VmPP = parcelRequire("2VmPP");

var $jjjbg = parcelRequire("jjjbg");

var $IoPSi = parcelRequire("IoPSi");

var $fVgSt = parcelRequire("fVgSt");

var $dnGcR = parcelRequire("dnGcR");

var $2MieS = parcelRequire("2MieS");

var $eOat1 = parcelRequire("eOat1");

var $Pxnvj = parcelRequire("Pxnvj");

var $5ZzwP = parcelRequire("5ZzwP");
var $bNEt5 = parcelRequire("bNEt5");
var $a4hJx = parcelRequire("a4hJx");
var $kxnYb = parcelRequire("kxnYb");
var $2zFxf = parcelRequire("2zFxf");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $jvcra = parcelRequire("jvcra");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $a2iZU = parcelRequire("a2iZU");

var $1UEDB = parcelRequire("1UEDB");

var $juTur = parcelRequire("juTur");

var $kZj7F = parcelRequire("kZj7F");

var $fxFUw = parcelRequire("fxFUw");

var $9S2q6 = parcelRequire("9S2q6");

var $g295Q = parcelRequire("g295Q");

var $aPRoZ = parcelRequire("aPRoZ");

var $dUk9j = parcelRequire("dUk9j");

var $cP24C = parcelRequire("cP24C");

var $9VXkC = parcelRequire("9VXkC");
var $doZTA = parcelRequire("doZTA");

var $6d15i = parcelRequire("6d15i");

var $ftojm = parcelRequire("ftojm");

var $ehvm7 = parcelRequire("ehvm7");

var $3EYjm = parcelRequire("3EYjm");

var $acFnr = parcelRequire("acFnr");
const $31a96ee8c0d32b5a$export$d9b273488cd8ce6f = ()=>{
    const [stack, setStack] = (0, $acFnr.useStack)();
    const [nestedAppOpen, setNestedAppOpen] = (0, $acFnr.useNestedAppOpen)();
    const { data: data, update: updateResource } = (0, $1UEDB.usePlan)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: { params: params } }] = (0, $doZTA.useRouter)();
    const { planId: planId, scenarioId: scenarioId } = params;
    const { clear: clearSummaryPageCache } = (0, $cP24C.useAdvancedRoadmapsSummaryDataResource)();
    const isCrossTeamPlanningTemplateEnabled = (0, $acFnr.isCrossTeamPlanningTemplateExperimentEnabled)();
    const generateHref = (0, $5uXOq.useCallback)((nextPage)=>{
        const basePath = (0, $9VXkC.generatePath)((0, $6d15i.PLANS_BASE_PATH), params);
        return nextPage ? `${basePath}/${nextPage}` : basePath;
    }, [
        params
    ]);
    const handleSettingsMenuItemClick = (0, $5uXOq.useCallback)((e)=>{
        clearSummaryPageCache();
        if (!e.metaKey && !e.ctrlKey) setNestedAppOpen(true);
    }, [
        setNestedAppOpen,
        clearSummaryPageCache
    ]);
    const onPlanStatusUpdated = (0, $5uXOq.useCallback)(()=>{
        if (data) {
            const newStatus = data.planStatus === 'ARCHIVED' ? 'ACTIVE' : 'ARCHIVED';
            updateResource((oldState)=>({
                    ...oldState || data,
                    planStatus: newStatus
                }));
        }
    }, [
        updateResource,
        data
    ]);
    const isSettingsPage = stack.includes((0, $6d15i.SECTION_ID).SETTINGS);
    const [submenuActive, setSubmenuActive] = (0, $5uXOq.useState)(isSettingsPage); // setting submenu active in an effect to prevent UI changes while transitioning.
    (0, $5uXOq.useEffect)(()=>{
        setSubmenuActive(isSettingsPage);
    }, [
        isSettingsPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $6d15i.MENU_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zFxf.default), {
        label: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNEt5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ftojm.PlanMenuHeader), {
        planId: planId,
        scenarioId: scenarioId,
        planTitle: data?.title ?? '',
        isReadOnly: data?.isReadOnly,
        isArchived: data?.planStatus === 'ARCHIVED',
        onPlanStatusUpdated: onPlanStatusUpdated
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4hJx.default), {
        stack: stack,
        onChange: setStack,
        isDefaultFocusControl: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2iZU.ScreenReaderMenuHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        delayOn: isSettingsPage,
        name: (0, $aPRoZ.Spotlights).Views
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31a96ee8c0d32b5a$export$e1ef03694abfd2eb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "summary-page-nav-item-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).summary
        },
        href: generateHref((0, $6d15i.PAGES).summary),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jjjbg))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-summary'
        ]
    }, formatMessage((0, $ehvm7.default).summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: "summary-page-nav-item-spotlight"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3EYjm.default), {
        submenuActive: submenuActive
    }, isCrossTeamPlanningTemplateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        delayOn: isSettingsPage,
        name: (0, $9S2q6.CtpSpotlights).Timeline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).timeline
        },
        href: generateHref((0, $6d15i.PAGES).timeline),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-timeline'
        ]
    }, formatMessage((0, $ehvm7.default).timeline))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).timeline
        },
        href: generateHref((0, $6d15i.PAGES).timeline),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-timeline'
        ]
    }, formatMessage((0, $ehvm7.default).timeline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).calendar
        },
        href: generateHref((0, $6d15i.PAGES).calendar),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VmPP))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-calendar'
        ]
    }, formatMessage((0, $ehvm7.default).calendar)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).increments
        },
        href: generateHref((0, $6d15i.PAGES).increments),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
            spacing: "spacious",
            label: formatMessage((0, $ehvm7.default).increments)
        }),
        selectedOn: [
            'software-plan-increments',
            'software-plan-increment'
        ]
    }, formatMessage((0, $ehvm7.default).increments), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $ehvm7.default).newLozenge))), isCrossTeamPlanningTemplateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        delayOn: isSettingsPage,
        name: (0, $9S2q6.CtpSpotlights).Teams
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).teams
        },
        href: generateHref((0, $6d15i.PAGES).teams),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IoPSi))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-teams'
        ]
    }, formatMessage((0, $ehvm7.default).teams))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).teams
        },
        href: generateHref((0, $6d15i.PAGES).teams),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IoPSi))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-teams'
        ]
    }, formatMessage((0, $ehvm7.default).teams)), data?.isReleaseEnabled === false && (0, $4R6GH.fg)('simple-plans-m2-release-feature-toggle') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).releases
        },
        href: generateHref((0, $6d15i.PAGES).releases),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MieS))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'software-plan-releases'
        ]
    }, formatMessage((0, $ehvm7.default).releases)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $6d15i.PAGES).dependenciesReport
        },
        href: generateHref((0, $6d15i.PAGES).dependenciesReport),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31a96ee8c0d32b5a$var$DependencyReportIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GFeY))), {
            spacing: "spacious",
            label: ""
        })),
        selectedOn: [
            'software-plan-dependencies'
        ]
    }, formatMessage((0, $ehvm7.default).dependencies)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        delayOn: isSettingsPage,
        name: (0, $g295Q.CttSpotlights).Settings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'settings'
        },
        href: generateHref('settings/scheduling'),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $6d15i.SECTION_ID).SETTINGS,
        title: formatMessage((0, $ehvm7.default).planSettings),
        onClick: handleSettingsMenuItemClick,
        overrides: {
            BackMenuItem: {
                href: generateHref('timeline'),
                title: formatMessage((0, $ehvm7.default).backToPlan),
                wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
                        delayOn: true,
                        name: (0, $g295Q.CttSpotlights).BackToPlan
                    }, children)
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationExpandableContentWrapper), {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        title: formatMessage((0, $ehvm7.default).general),
        headingLevel: 3,
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/plan-info'
        },
        href: generateHref('settings/plan-info'),
        selectedOn: [
            'plan-settings-plan-info'
        ]
    }, formatMessage((0, $ehvm7.default).planInfo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/scheduling'
        },
        href: generateHref('settings/scheduling'),
        selectedOn: [
            'plan-settings-scheduling'
        ]
    }, formatMessage((0, $ehvm7.default).scheduling)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/saved-views'
        },
        href: generateHref('settings/saved-views'),
        selectedOn: [
            'plan-settings-saved-views'
        ]
    }, formatMessage((0, $ehvm7.default).savedViews)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/program-boards'
        },
        href: generateHref('settings/program-boards'),
        selectedOn: [
            'plan-settings-program-boards'
        ]
    }, formatMessage((0, $ehvm7.default).programBoards), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $ehvm7.default).newLozenge))))), !data?.isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationExpandableContentWrapper), {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        headingLevel: 3,
        title: formatMessage((0, $ehvm7.default).sourceData),
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        delayOn: isSettingsPage,
        name: (0, $g295Q.CttSpotlights).IssueSources
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/issue-sources'
        },
        href: generateHref('settings/issue-sources'),
        selectedOn: [
            'plan-settings-issue-sources'
        ]
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $ehvm7.default).issueSourcesIssueTermRefresh : (0, $ehvm7.default).issueSources))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/exclusion-rules'
        },
        href: generateHref('settings/exclusion-rules'),
        selectedOn: [
            'plan-settings-exclusion-rules'
        ]
    }, formatMessage((0, $ehvm7.default).exclusionRules)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/removed-issues'
        },
        href: generateHref('settings/removed-issues'),
        selectedOn: [
            'plan-settings-removed-issues'
        ]
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $ehvm7.default).removedIssuesIssueTermRefresh : (0, $ehvm7.default).removedIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/find-your-issue'
        },
        href: generateHref('settings/find-your-issue'),
        selectedOn: [
            'plan-settings-find-your-issue'
        ]
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $ehvm7.default).findYourIssueIssueTermRefresh : (0, $ehvm7.default).findYourIssue)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/custom-fields'
        },
        href: generateHref('settings/custom-fields'),
        selectedOn: [
            'plan-settings-custom-fields'
        ]
    }, formatMessage((0, $ehvm7.default).customFields)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationExpandableContentWrapper), {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        headingLevel: 3,
        title: formatMessage((0, $ehvm7.default).accessControl),
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/permissions'
        },
        href: generateHref('settings/permissions'),
        selectedOn: [
            'plan-settings-permissions'
        ]
    }, formatMessage((0, $ehvm7.default).permissions))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationExpandableContentWrapper), {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        title: formatMessage((0, $ehvm7.default).advanced),
        headingLevel: 3,
        submenuActive: submenuActive
    }, (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/features'
        },
        href: generateHref('settings/features'),
        selectedOn: [
            'plan-settings-features'
        ]
    }, formatMessage((0, $ehvm7.default).features)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/scenarios'
        },
        href: generateHref('settings/scenarios'),
        selectedOn: [
            'plan-settings-scenarios'
        ]
    }, formatMessage((0, $ehvm7.default).scenarios)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'settings/auto-scheduler'
        },
        href: generateHref('settings/auto-scheduler'),
        selectedOn: [
            'plan-settings-auto-scheduler'
        ]
    }, formatMessage((0, $ehvm7.default).autoScheduler))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZzwP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxFUw.ProjectFooter), {
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            spacing: "none",
            appearance: "subtle-link",
            href: "https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/",
            target: "_blank"
        }, formatMessage((0, $ehvm7.default).footerWhatArePlans))
    }, ' '))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31a96ee8c0d32b5a$var$DependencyReportIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_t9ec14w8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $31a96ee8c0d32b5a$export$e1ef03694abfd2eb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0196n _2hwx196n _19bv12x7 _u5f312x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8GFeY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65323c75748d52d3$var$_react = $65323c75748d52d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $65323c75748d52d3$var$_branch = $65323c75748d52d3$var$_interopRequireDefault((parcelRequire("dTsWf")));

var $65323c75748d52d3$var$_branches = $65323c75748d52d3$var$_interopRequireDefault((parcelRequire("1OKia")));
function $65323c75748d52d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65323c75748d52d3$var$BranchIcon = (props)=>/*#__PURE__*/ $65323c75748d52d3$var$_react.default.createElement($65323c75748d52d3$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $65323c75748d52d3$var$_branches.default
    }, props));
$65323c75748d52d3$var$BranchIcon.Name = 'BranchIconMigration';
var $65323c75748d52d3$var$_default = module.exports.default = $65323c75748d52d3$var$BranchIcon;

});
parcelRegister("dTsWf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1d6dbfded07c90a$var$_react = $a1d6dbfded07c90a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1d6dbfded07c90a$var$_baseNew = $a1d6dbfded07c90a$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a1d6dbfded07c90a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1d6dbfded07c90a$var$BranchIcon = (props)=>/*#__PURE__*/ $a1d6dbfded07c90a$var$_react.default.createElement($a1d6dbfded07c90a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$a1d6dbfded07c90a$var$BranchIcon.displayName = 'BranchIcon';
var $a1d6dbfded07c90a$var$_default = module.exports.default = $a1d6dbfded07c90a$var$BranchIcon;

});

parcelRegister("1OKia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $152e5e919294fc42$var$_react = $152e5e919294fc42$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $152e5e919294fc42$var$_branch = $152e5e919294fc42$var$_interopRequireDefault((parcelRequire("dTsWf")));
function $152e5e919294fc42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $152e5e919294fc42$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $152e5e919294fc42$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $152e5e919294fc42$var$_branch.default
    }));
$152e5e919294fc42$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $152e5e919294fc42$var$_default = module.exports.default = $152e5e919294fc42$var$BitbucketBranchesIcon;

});


parcelRegister("2VmPP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22129e2c287d5de4$var$_react = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $22129e2c287d5de4$var$_calendar = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("iTgNO")));

var $22129e2c287d5de4$var$_calendar2 = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("kqwhU")));
function $22129e2c287d5de4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22129e2c287d5de4$var$CalendarIcon = (props)=>/*#__PURE__*/ $22129e2c287d5de4$var$_react.default.createElement($22129e2c287d5de4$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $22129e2c287d5de4$var$_calendar2.default
    }, props));
$22129e2c287d5de4$var$CalendarIcon.Name = 'CalendarIconMigration';
var $22129e2c287d5de4$var$_default = module.exports.default = $22129e2c287d5de4$var$CalendarIcon;

});
parcelRegister("iTgNO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc0a65a8f23cfe26$var$_react = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dc0a65a8f23cfe26$var$_baseNew = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("enEmH")));
function $dc0a65a8f23cfe26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc0a65a8f23cfe26$var$CalendarIcon = (props)=>/*#__PURE__*/ $dc0a65a8f23cfe26$var$_react.default.createElement($dc0a65a8f23cfe26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$dc0a65a8f23cfe26$var$CalendarIcon.displayName = 'CalendarIcon';
var $dc0a65a8f23cfe26$var$_default = module.exports.default = $dc0a65a8f23cfe26$var$CalendarIcon;

});

parcelRegister("kqwhU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edef480bec250815$var$_react = $edef480bec250815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $edef480bec250815$var$_calendar = $edef480bec250815$var$_interopRequireDefault((parcelRequire("iTgNO")));
function $edef480bec250815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $edef480bec250815$var$CalendarIcon = (props)=>/*#__PURE__*/ $edef480bec250815$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $edef480bec250815$var$_calendar.default
    }));
$edef480bec250815$var$CalendarIcon.displayName = 'CalendarIcon';
var $edef480bec250815$var$_default = module.exports.default = $edef480bec250815$var$CalendarIcon;

});


parcelRegister("5ZzwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a61c4dfff08e7bae$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $a61c4dfff08e7bae$var$styles = {
    navigationFooter: "_kqswh2mm"
};
/**
 * __Navigation footer__
 *
 * Allows for customisation of the footer.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $a61c4dfff08e7bae$var$NavigationFooter = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        padding: "space.100",
        paddingBlockEnd: "space.200",
        xcss: $a61c4dfff08e7bae$var$styles.navigationFooter,
        children: children
    });
};
var $a61c4dfff08e7bae$export$2e2bcd8739ae039 = $a61c4dfff08e7bae$var$NavigationFooter;

});

parcelRegister("bNEt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ac19a84e29fc0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $17ac19a84e29fc0b$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $17ac19a84e29fc0b$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $17ac19a84e29fc0b$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $17ac19a84e29fc0b$export$2e2bcd8739ae039 = $17ac19a84e29fc0b$var$NavigationHeader;

});

parcelRegister("a4hJx", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $60ed2743269ce34a$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $60ed2743269ce34a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7xhdA = parcelRequire("7xhdA");

var $fHpHg = parcelRequire("fHpHg");

var $79Hag = parcelRequire("79Hag");

var $65Cwx = parcelRequire("65Cwx");

var $4bO8w = parcelRequire("4bO8w");

var $fsi33 = parcelRequire("fsi33");

var $atNen = parcelRequire("atNen");
const $60ed2743269ce34a$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $60ed2743269ce34a$var$nestableNavigationContentStyles = null;
const $60ed2743269ce34a$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $60ed2743269ce34a$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $60ed2743269ce34a$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $fHpHg.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $79Hag.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $4bO8w.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $60ed2743269ce34a$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atNen.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsi33.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $65Cwx.default), {
                                    title: "",
                                    id: $60ed2743269ce34a$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $60ed2743269ce34a$export$2e2bcd8739ae039 = $60ed2743269ce34a$var$NestableNavigationContent;

});
parcelRegister("79Hag", function(module, exports) {

$parcel$export(module.exports, "default", () => $46dfc43720f75948$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3xWPD = parcelRequire("3xWPD");


var $4iTJw = parcelRequire("4iTJw");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $46dfc43720f75948$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xWPD))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4iTJw.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $46dfc43720f75948$export$2e2bcd8739ae039 = $46dfc43720f75948$var$GoBackItem;

});
parcelRegister("3xWPD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295216f354fff637$var$_react = $295216f354fff637$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $295216f354fff637$var$_arrowLeft = $295216f354fff637$var$_interopRequireDefault((parcelRequire("kmtfL")));

var $295216f354fff637$var$_arrowLeftCircle = $295216f354fff637$var$_interopRequireDefault((parcelRequire("2H8VS")));
function $295216f354fff637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295216f354fff637$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $295216f354fff637$var$_react.default.createElement($295216f354fff637$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $295216f354fff637$var$_arrowLeftCircle.default
    }, props));
$295216f354fff637$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $295216f354fff637$var$_default = module.exports.default = $295216f354fff637$var$ArrowLeftIcon;

});
parcelRegister("2H8VS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f6686b5a2de8be4$var$_react = $1f6686b5a2de8be4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1f6686b5a2de8be4$var$_arrowLeft = $1f6686b5a2de8be4$var$_interopRequireDefault((parcelRequire("kmtfL")));
function $1f6686b5a2de8be4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f6686b5a2de8be4$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $1f6686b5a2de8be4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $1f6686b5a2de8be4$var$_arrowLeft.default
    }));
$1f6686b5a2de8be4$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $1f6686b5a2de8be4$var$_default = module.exports.default = $1f6686b5a2de8be4$var$ArrowLeftCircleIcon;

});


var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';

parcelRegister("4iTJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $23465bf5670bf66e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7H980 = parcelRequire("7H980");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $23465bf5670bf66e$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $c48kn.overrideStyleFunction)((0, $c48kn.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $23465bf5670bf66e$export$2e2bcd8739ae039 = $23465bf5670bf66e$var$ButtonItem;

});


parcelRegister("65Cwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee06468e5ae9b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gA2o = parcelRequire("6gA2o");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");


var $c48kn = parcelRequire("c48kn");

var $4iTJw = parcelRequire("4iTJw");
var $bY5Mc = parcelRequire("bY5Mc");
var $2uGoK = parcelRequire("2uGoK");

var $a4hJx = parcelRequire("a4hJx");

var $fsi33 = parcelRequire("fsi33");

var $4bO8w = parcelRequire("4bO8w");

var $hE0bV = parcelRequire("hE0bV");
const $1fee06468e5ae9b2$var$styles = {
    iconContainer: "_1e0c1nu9"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $1fee06468e5ae9b2$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $fsi33.useNestedContext)();
    const mergedStyles = (0, $c48kn.overrideStyleFunction)((0, $hE0bV.nestingItemStyle), cssFn);
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $fHpHg.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $4bO8w.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fsi33.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uGoK.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $a4hJx.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $1fee06468e5ae9b2$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    "data-right-arrow": true,
                    xcss: $1fee06468e5ae9b2$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6gA2o))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title,
        cssFn: mergedStyles
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4iTJw.default), {
        ref: activeParentRef,
        ...componentProps
    });
};
var $1fee06468e5ae9b2$export$2e2bcd8739ae039 = $1fee06468e5ae9b2$var$NestingItem;

});
parcelRegister("6gA2o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $490030febd58df31$var$_react = $490030febd58df31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $490030febd58df31$var$_arrowRight = $490030febd58df31$var$_interopRequireDefault((parcelRequire("kAczT")));

var $490030febd58df31$var$_arrowRightCircle = $490030febd58df31$var$_interopRequireDefault((parcelRequire("ax5oF")));
function $490030febd58df31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $490030febd58df31$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $490030febd58df31$var$_react.default.createElement($490030febd58df31$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $490030febd58df31$var$_arrowRightCircle.default
    }, props));
$490030febd58df31$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $490030febd58df31$var$_default = module.exports.default = $490030febd58df31$var$ArrowRightIcon;

});
parcelRegister("kAczT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efc0ed230d3ca890$var$_react = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $efc0ed230d3ca890$var$_baseNew = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("enEmH")));
function $efc0ed230d3ca890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efc0ed230d3ca890$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $efc0ed230d3ca890$var$_react.default.createElement($efc0ed230d3ca890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$efc0ed230d3ca890$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $efc0ed230d3ca890$var$_default = module.exports.default = $efc0ed230d3ca890$var$ArrowRightIcon;

});

parcelRegister("ax5oF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ab12c2904bc0560$var$_react = $7ab12c2904bc0560$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7ab12c2904bc0560$var$_arrowRight = $7ab12c2904bc0560$var$_interopRequireDefault((parcelRequire("kAczT")));
function $7ab12c2904bc0560$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ab12c2904bc0560$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7ab12c2904bc0560$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $7ab12c2904bc0560$var$_arrowRight.default
    }));
$7ab12c2904bc0560$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7ab12c2904bc0560$var$_default = module.exports.default = $7ab12c2904bc0560$var$ArrowRightCircleIcon;

});


parcelRegister("bY5Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bca491cca55dea$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2COCu = parcelRequire("2COCu");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $f1bca491cca55dea$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $c48kn.overrideStyleFunction)((0, $c48kn.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2COCu.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $f1bca491cca55dea$export$2e2bcd8739ae039 = $f1bca491cca55dea$var$CustomItem;

});

parcelRegister("2uGoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522d7db65b02790$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iIWB4 = parcelRequire("iIWB4");

var $fsi33 = parcelRequire("fsi33");
const $0522d7db65b02790$var$outerContainerCSS = null;
const $0522d7db65b02790$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $0522d7db65b02790$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $0522d7db65b02790$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    const scrollbar = (0, $iIWB4.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $0522d7db65b02790$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $0522d7db65b02790$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $0522d7db65b02790$var$containerCSS.basic,
                    showTopScrollIndicator && $0522d7db65b02790$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $0522d7db65b02790$export$2e2bcd8739ae039 = $0522d7db65b02790$var$NavigationContent;

});
parcelRegister("iIWB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e79fe7c7a46990$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $16e79fe7c7a46990$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("4bO8w", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $59c19cb7551d7415$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $59c19cb7551d7415$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $a4hJx = parcelRequire("a4hJx");
const $59c19cb7551d7415$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $a4hJx.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $59c19cb7551d7415$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("hE0bV", function(module, exports) {

$parcel$export(module.exports, "nestingItemStyle", () => $9bf7631033ec0b7d$export$38e770f85519b259);
const $9bf7631033ec0b7d$export$4c36b5b1b67ee1e8 = {
    ['&:hover [data-custom-icon]']: {
        display: 'none'
    },
    ['&:active [data-custom-icon]']: {
        display: 'none'
    },
    ['&:focus [data-custom-icon]']: {
        display: 'none'
    },
    ['& [data-custom-icon]']: {
        display: 'inherit'
    },
    ['&:hover [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:active [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:focus [data-right-arrow]']: {
        display: 'inherit'
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $9bf7631033ec0b7d$var$disabledCSS = {
    ['[data-item-elem-after]']: {
        opacity: 0
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $9bf7631033ec0b7d$export$38e770f85519b259 = (state)=>{
    return {
        ...state.isDisabled ? $9bf7631033ec0b7d$var$disabledCSS : $9bf7631033ec0b7d$export$4c36b5b1b67ee1e8
    };
};

});


parcelRegister("atNen", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $73b6973e2eaccf98$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3aB43 = parcelRequire("3aB43");
const $73b6973e2eaccf98$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aB43.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("2zFxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $75770a0a8b5fef07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8ZVfC = parcelRequire("8ZVfC");
const $75770a0a8b5fef07$var$sidebarMinWidth = '240px';
const $75770a0a8b5fef07$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $75770a0a8b5fef07$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $75770a0a8b5fef07$export$2e2bcd8739ae039 = $75770a0a8b5fef07$var$SideNavigation;

});

parcelRegister("jvcra", function(module, exports) {

$parcel$export(module.exports, "ExpandableSection", () => $181ed316b1c5154e$export$e86ef41bc845761);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $1u5XK = parcelRequire("1u5XK");
var $kxnYb = parcelRequire("kxnYb");

var $gwIPs = parcelRequire("gwIPs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $4R6GH = parcelRequire("4R6GH");

var $fXJBp = parcelRequire("fXJBp");
const $181ed316b1c5154e$export$e86ef41bc845761 = (props)=>{
    const { title: title = '', submenuActive: submenuActive = false, isCollapsed: isCollapsed = false, hasSeparator: hasSeparator = false, removeTitleSection: removeTitleSection = false, testId: testId = '', headingLevel: headingLevel, expandClick: expandClick, context: context } = props;
    const [expanded, setExpanded] = (0, $5uXOq.useState)(true);
    const [showCaret, setShowCaret] = (0, $5uXOq.useState)(!expanded && !submenuActive);
    const [removeCaret, setRemoveCaret] = (0, $5uXOq.useState)(submenuActive);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const expandButtonId = title != null ? title.replace(/ /g, '-').toLowerCase() : '';
    const onContainerMouseOver = (0, $5uXOq.useCallback)(()=>{
        if (expanded && !submenuActive) setShowCaret(true);
        if (submenuActive) setShowCaret(false);
    }, [
        expanded,
        submenuActive
    ]);
    const onContainerMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (expanded) setShowCaret(false);
    }, [
        expanded
    ]);
    const onExpandButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'navModules', {
            navModulesId: title,
            expanded: !expanded
        });
        setExpanded(!expanded);
        if (expandClick) expandClick();
    }, [
        createAnalyticsEvent,
        title,
        expanded,
        expandClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!expanded) setShowCaret(true);
    }, [
        expanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (submenuActive) setRemoveCaret(true);
        else setRemoveCaret(false);
    }, [
        submenuActive
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setExpanded(!isCollapsed);
    }, [
        isCollapsed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (removeTitleSection) setExpanded(true);
    }, [
        removeTitleSection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($181ed316b1c5154e$var$Container, {
        onMouseOver: onContainerMouseOver,
        onMouseLeave: onContainerMouseLeave,
        submenuActive: submenuActive,
        removeTitleSection: removeTitleSection,
        context: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXJBp.ExpandButton), {
        isExpanded: expanded || removeTitleSection,
        id: expandButtonId,
        isActive: true,
        label: props.title || '',
        onClick: onExpandButtonClick,
        size: "medium",
        isVisible: showCaret,
        removeCaret: removeCaret || removeTitleSection,
        tabIndex: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: hasSeparator,
        testId: testId,
        title: (0, $4R6GH.fg)('blu-6205_nav3_sidebar_a11y_fix') ? title : undefined
    }, title && !(0, $4R6GH.fg)('blu-6205_nav3_sidebar_a11y_fix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u5XK.default), {
        headingLevel: headingLevel
    }, title), expanded && props.children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $181ed316b1c5154e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, removeTitleSection: removeTitleSection, context: context, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _18u0yr36 _rh951ule _1hoi1gjq _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive || __cmplp.removeTitleSection ? "_19pkidpf" : "_19pkdlk8",
            __cmplp.submenuActive ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.submenuActive ? "_4t3i1osq" : "_4t3i1wug",
            __cmplp.submenuActive || __cmplp.removeTitleSection ? "_1xpp1osq" : "_1xpp5cnj",
            __cmplp.submenuActive ? "_1ipydlk8" : "_1ipy196n",
            __cmplp.submenuActive ? "_1ly419bv" : "_1ly4idpf",
            __cmplp.removeTitleSection ? "_135pglyw" : "_135p1ule",
            __cmplp.removeTitleSection ? "_15skidpf _178kidpf _18pcidpf _1bc7idpf" : "_15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z",
            __cmplp.removeTitleSection && "_ik0tidpf",
            !__cmplp.submenuActive && "_2rkoi2wt _189eyh40 _1dqonqa1 _1h6d3acm _2hwx196n _ca0qu2gc _19pkv77o _u5f314y2",
            __cmplp.removeTitleSection && "_ca0qidpf _19pkidpf",
            __cmplp.submenuActive && "_18u0idpf",
            !__cmplp.submenuActive && __cmplp.removeTitleSection && "_18u01skh",
            !__cmplp.submenuActive && !__cmplp.removeTitleSection && __cmplp.context !== 'classic' && "_18u0yr36",
            !__cmplp.submenuActive && !__cmplp.removeTitleSection && __cmplp.context === 'classic' && "_18u0d439",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1u5XK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8a315ea852f524$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $d6a7c = parcelRequire("d6a7c");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $4b8a315ea852f524$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssFn = (0, $c48kn.overrideStyleFunction)((0, $c48kn.sectionHeaderSpacingStyles), props.cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d6a7c.default), {
        ...props,
        cssFn: cssFn
    });
};
var $4b8a315ea852f524$export$2e2bcd8739ae039 = $4b8a315ea852f524$var$HeadingItem;

});

parcelRegister("fXJBp", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cUaD8 = parcelRequire("cUaD8");

var $GYj5l = parcelRequire("GYj5l");

var $jVpd1 = parcelRequire("jVpd1");

var $LD2gx = parcelRequire("LD2gx");

var $0yZbT = parcelRequire("0yZbT");

var $dCm1o = parcelRequire("dCm1o");
const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const ChevronOld = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($cUaD8))) : (0, (/*@__PURE__*/$parcel$interopDefault($GYj5l)));
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))) : (0, (/*@__PURE__*/$parcel$interopDefault($LD2gx)));
    const onKeydown = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        padding: "space.075",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
        testId: `sidebar.expand-button.container-${id}`,
        color: "var(--ds-icon, #44546F)",
        label: label
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: "var(--ds-icon, #44546F)",
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3120c1c485e5e18$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _kqswh2mm _4t3i1osq _bfhk18uv _80omtlke _1spjglyw _1ejjufon _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $bY5Mc = parcelRequire("bY5Mc");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $bY5Mc.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("a2iZU", function(module, exports) {

$parcel$export(module.exports, "ScreenReaderMenuHeader", () => $e545e14b3034e9ee$export$e4974841dcf2a587);

var $5uXOq = parcelRequire("5uXOq");

var $1u5XK = parcelRequire("1u5XK");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $lHJgi = parcelRequire("lHJgi");
const $e545e14b3034e9ee$export$e4974841dcf2a587 = ({ title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const defaultTitle = formatMessage((0, $lHJgi.messages).sideBarNavigationTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u5XK.default), {
        headingLevel: 2
    }, title || defaultTitle));
};

});
parcelRegister("lHJgi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5890a868407d596f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5890a868407d596f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sideBarNavigationTitle: {
        "id": "spa-apps-sidebar-common.common.screen-reader-header.side-bar-navigation-title",
        "defaultMessage": "Menu"
    }
});

});


parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $1UikQ = parcelRequire("1UikQ");

var $3xWPD = parcelRequire("3xWPD");

var $65Cwx = parcelRequire("65Cwx");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $hg4VT = parcelRequire("hg4VT");

var $kZ5sr = parcelRequire("kZ5sr");

var $fpoBX = parcelRequire("fpoBX");

var $ai0LF = parcelRequire("ai0LF");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$customCssFn = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
    const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
    const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
    const newStyle = {
        ...(0, $kZ5sr.cssFn)(currentStateAndStyles),
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            color: activeColor
        },
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus': {
            color: baseColor
        },
        '& [data-item-title]': {
            color: baseColor
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStateAndStyles, newStyle);
});
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const backButtonCssFn = (0, $hg4VT.generateBackButtonCssFn)(theme);
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xWPD))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            cssFn: backButtonCssFn
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backButtonCssFn,
        backTitle
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65Cwx.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: customItemCssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
                customItemCssFn,
                $2fbfde7c900477f4$var$customCssFn
            ]) : $2fbfde7c900477f4$var$customCssFn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("hg4VT", function(module, exports) {

$parcel$export(module.exports, "generateBackButtonCssFn", () => $1e5fb9a53caeb1aa$export$56644251c3f2ea82);
const $1e5fb9a53caeb1aa$export$56644251c3f2ea82 = (theme)=>()=>{
        if (theme?.navigation) {
            const { icon: icon } = theme.navigation;
            return {
                '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                    color: icon?.secondary?.color?.active ?? undefined
                }
            };
        }
        return {};
    };

});

parcelRegister("kZ5sr", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $399c9dca906145c0$export$d722961e96b459c5);

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $ai0LF = parcelRequire("ai0LF");
const $399c9dca906145c0$export$d722961e96b459c5 = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-item-elem-after] [data-right-arrow]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-right-arrow])': {
                display: 'none'
            },
            '& [data-right-arrow]': {
                display: 'flex'
            }
        },
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
});

});
parcelRegister("ai0LF", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $2bb346e8dcf8bbae$export$3f662b014fa1806e);
function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}

});



parcelRegister("fxFUw", function(module, exports) {

$parcel$export(module.exports, "ProjectFooter", () => $60f5e4c9257f773e$export$84c2ab70be8ad47b);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1lATI = parcelRequire("1lATI");

var $fpoBX = parcelRequire("fpoBX");
const $60f5e4c9257f773e$var$bgColorCssVar = '--project-footer-bg-color';
const $60f5e4c9257f773e$var$textColorCssVar = '--project-footer-text-color';
const $60f5e4c9257f773e$var$customFooterStyles = null;
const $60f5e4c9257f773e$var$bgColorThemeStyles = null;
const $60f5e4c9257f773e$var$colorThemeStyles = null;
const $60f5e4c9257f773e$export$88140d3970f0ce84 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf _tkqh1ule _1g6a1h6o _dqi54jg8 _1lfu4jg8 _1bnm1gjq _1t3912x7 _qz5b12x7 _xd2912x7 _2i0812x7 _2pzv1o8l _1w711gjq",
            item?.background?.default && "_16hg1p3a",
            item?.color?.default && "_1w90enff _i9a1enff _1cmdenff",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$60f5e4c9257f773e$var$bgColorCssVar]: item?.background?.default,
            [$60f5e4c9257f773e$var$textColorCssVar]: item?.color?.default
        }
    });
};
const $60f5e4c9257f773e$export$84c2ab70be8ad47b = ({ Footer: Footer = (0, $1lATI.default), children: children, description: description })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        component: $60f5e4c9257f773e$export$88140d3970f0ce84,
        // @ts-expect-error - TS2769 - No overload matches this call.
        description: description,
        testId: "navigation-apps-sidebar-common.ui.project-footer.test-footer"
    }, children);
};

});
parcelRegister("1lATI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df4485cd7f519a3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $5sRpy = parcelRequire("5sRpy");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $3w19c = parcelRequire("3w19c");

var $bY5Mc = parcelRequire("bY5Mc");

var $6cAn5 = parcelRequire("6cAn5");
const $7df4485cd7f519a3$var$styles = {
    iconContainer: "_1e0c1o8l _1bsb1k8s _4t3i1k8s",
    oldFooter: "_vrjtdcr7 _16vx1h6o _1cg71wug _if291ule _14741h6o _oiqe1tcg _1kba1h6o _w1ap1osq _1mt2ze3t _159iu2gc _76zj1o8l _13e21h6o _14bw1o8l _eq7s12x7 _1jkv12x7 _1rla12x7 _z2a212x7 _11kj1w7a _jl2n73ad _1et61w7a _1v6jjjyb"
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $7df4485cd7f519a3$var$OldFooter = (props)=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ iconBefore: iconBefore, onClick: onClick, description: description, children: children, testId: testId })=>({
            iconBefore: iconBefore,
            onClick: onClick,
            description: description,
            children: children,
            testId: testId
        }))(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ...safeProps,
        component: props.component || (0, $3w19c.Container),
        className: (0, $bwpsq.default)([
            $7df4485cd7f519a3$var$styles.oldFooter
        ])
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $7df4485cd7f519a3$var$Footer = ({ description: description, children: children, iconBefore: iconBefore, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        padding: "space.100",
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
            space: "space.100",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $7df4485cd7f519a3$var$styles.iconContainer,
                    children: iconBefore
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "UNSAFE_small",
                            align: "center",
                            color: "inherit",
                            children: children
                        }),
                        description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "UNSAFE_small",
                            as: "p",
                            align: "center",
                            color: "color.text.subtlest",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $7df4485cd7f519a3$var$FooterFacade = ({ useDeprecatedApi: useDeprecatedApi = true, description: description, iconBefore: iconBefore, testId: testId, children: children, component: component, onClick: onClick })=>{
    if (!useDeprecatedApi) return /*#__PURE__*/ (0, $2OMIu.jsx)($7df4485cd7f519a3$var$Footer, {
        iconBefore: iconBefore,
        description: description,
        testId: testId,
        children: children
    });
    typeof $6cAn5;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7df4485cd7f519a3$var$OldFooter, {
        onClick: onClick,
        component: component,
        iconBefore: iconBefore,
        description: description,
        testId: testId,
        children: children
    });
};
var $7df4485cd7f519a3$export$2e2bcd8739ae039 = $7df4485cd7f519a3$var$FooterFacade;

});
parcelRegister("3w19c", function(module, exports) {

$parcel$export(module.exports, "Container", () => $54b2e099858dbc74$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $54b2e099858dbc74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bY5Mc = parcelRequire("bY5Mc");
const $54b2e099858dbc74$var$styles = {
    header: "_vrjt140y _1cmd10s3 _1cg71wug _11kj1w7a _jl2n73ad _1et61w7a _1v6j10s3"
};
const $54b2e099858dbc74$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $54b2e099858dbc74$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ...props,
        ref: ref,
        component: props.component || $54b2e099858dbc74$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
                        ...props,
                        children: children
                    })
            }
        },
        className: (0, $bwpsq.default)([
            $54b2e099858dbc74$var$styles.header
        ])
    });
});
var $54b2e099858dbc74$export$2e2bcd8739ae039 = $54b2e099858dbc74$var$Header;

});



parcelRegister("9S2q6", function(module, exports) {

$parcel$export(module.exports, "CtpSpotlights", () => $377b15b17e43b5a6$export$79ec23ebaf903d75);
const $377b15b17e43b5a6$export$79ec23ebaf903d75 = {
    Inactive: 'INACTIVE',
    Timeline: 'portfolio-3/ctp-onboarding/timeline',
    CreateIssue: 'portfolio-3/ctp-onboarding/create-issue',
    Teams: 'portfolio-3/ctp-onboarding/teams',
    Boards: 'portfolio-3/ctp-onboarding/boards'
};

});

parcelRegister("cP24C", function(module, exports) {

$parcel$export(module.exports, "useAdvancedRoadmapsSummaryDataResource", () => $d012d2ead08788e3$export$263a4c831540778e);

var $2YP9W = parcelRequire("2YP9W");

var $lv9xW = parcelRequire("lv9xW");

var $lv9xW = parcelRequire("lv9xW");


var $gZ6zR = parcelRequire("gZ6zR");
const $d012d2ead08788e3$export$263a4c831540778e = ()=>(0, $2YP9W.useResource)((0, $lv9xW.advancedRoadmapsSummaryDataResource));

});
parcelRegister("lv9xW", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $f87ae7e2901ac155$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $f87ae7e2901ac155$export$2dfe99460dae6bc6);

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

var $5m5rT = parcelRequire("5m5rT");

var $iz4dr = parcelRequire("iz4dr");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $f87ae7e2901ac155$export$f9061628830b5175 = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, $5m5rT.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    if ((0, $4R6GH.fg)('smart_links_for_plans')) {
        const dateRange = (0, $iz4dr.validateDateRange)((0, $iz4dr.parseDateRange)($f87ae7e2901ac155$var$getQueryParams(query)));
        const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...dateRange ? {
                    dateRange: dateRange
                } : {}
            })
        });
        return dateRange ? {
            ...data,
            customDateRange: dateRange
        } : data;
    }
    const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
    const customDateRangeParams = startDate && endDate ? {
        startDate: startDate,
        endDate: endDate
    } : {};
    const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...customDateRangeParams
        })
    });
    return data;
};

});
parcelRegister("5m5rT", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $d315f648a94f47c0$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $d315f648a94f47c0$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $d315f648a94f47c0$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $d315f648a94f47c0$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $d315f648a94f47c0$export$38e437924c2adbda);
const $d315f648a94f47c0$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $d315f648a94f47c0$export$79cf9c14f738d70b = [
    $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
    $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
    $d315f648a94f47c0$export$3251435144ca69e2.blockers,
    $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
    $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
    $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
    $d315f648a94f47c0$export$3251435144ca69e2.overdue
];
const $d315f648a94f47c0$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $d315f648a94f47c0$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $d315f648a94f47c0$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("iz4dr", function(module, exports) {

$parcel$export(module.exports, "parseDateRange", () => $8d575024c745c5c9$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $8d575024c745c5c9$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $gZ6zR = parcelRequire("gZ6zR");
const $8d575024c745c5c9$export$637d8b0948b783c7 = {
    [(0, $gZ6zR.DATE_UNITS).DAYS]: 3650,
    [(0, $gZ6zR.DATE_UNITS).WEEKS]: 520,
    [(0, $gZ6zR.DATE_UNITS).MONTHS]: 120
};
const $8d575024c745c5c9$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $8d575024c745c5c9$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $gZ6zR.DATE_UNITS).DAYS:
        case (0, $gZ6zR.DATE_UNITS).WEEKS:
        case (0, $gZ6zR.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $8d575024c745c5c9$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(toNowUnit)
    };
};
const $8d575024c745c5c9$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $8d575024c745c5c9$export$637d8b0948b783c7[unit];
};
const $8d575024c745c5c9$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $8d575024c745c5c9$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $8d575024c745c5c9$export$68346777682e262(toNowUnitCount, toNowUnit) && $8d575024c745c5c9$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED && $8d575024c745c5c9$export$1ba31c57b50b4374(fromDate) && $8d575024c745c5c9$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("gZ6zR", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $ad83cd0410dc011b$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $ad83cd0410dc011b$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $ad83cd0410dc011b$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $ad83cd0410dc011b$export$48808c686fe495c4);
const $ad83cd0410dc011b$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $ad83cd0410dc011b$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $ad83cd0410dc011b$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $ad83cd0410dc011b$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});




parcelRegister("6d15i", function(module, exports) {

$parcel$export(module.exports, "MENU_ID", () => $7a4ef98a34bf6c6b$export$d4cd258d01c03112);
$parcel$export(module.exports, "PLAN_MENU_ANALYTICS", () => $7a4ef98a34bf6c6b$export$57246c867f8b66);
$parcel$export(module.exports, "PLANS_BASE_PATH", () => $7a4ef98a34bf6c6b$export$34cc74acf6c77026);
$parcel$export(module.exports, "PAGES", () => $7a4ef98a34bf6c6b$export$bf0267afb2fbc151);
$parcel$export(module.exports, "SECTION_ID", () => $7a4ef98a34bf6c6b$export$501955bd67991a25);
const $7a4ef98a34bf6c6b$export$d4cd258d01c03112 = 'plan';
const $7a4ef98a34bf6c6b$export$57246c867f8b66 = 'plan-menu';
const $7a4ef98a34bf6c6b$export$34cc74acf6c77026 = '/jira/plans/:planId/scenarios/:scenarioId';
const $7a4ef98a34bf6c6b$export$bf0267afb2fbc151 = {
    dependenciesReport: 'dependencies',
    increments: 'program',
    releases: 'releases',
    summary: 'summary',
    calendar: 'calendar',
    teams: 'teams',
    timeline: 'timeline'
};
const $7a4ef98a34bf6c6b$export$501955bd67991a25 = {
    SETTINGS: 'settings'
};

});

parcelRegister("ftojm", function(module, exports) {

$parcel$export(module.exports, "PlanMenuHeader", () => $2f431e60ef086510$export$e3a5d921ad306755);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $dGKFs = parcelRequire("dGKFs");

var $6P0Kj = parcelRequire("6P0Kj");

var $jVpd1 = parcelRequire("jVpd1");

var $3w19c = parcelRequire("3w19c");

var $koVbs = parcelRequire("koVbs");

var $8pynQ = parcelRequire("8pynQ");

var $4hkqI = parcelRequire("4hkqI");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dCm1o = parcelRequire("dCm1o");

var $6d15i = parcelRequire("6d15i");

var $7cLs0 = parcelRequire("7cLs0");


var $laDtS = parcelRequire("laDtS");

var $ixnGT = parcelRequire("ixnGT");

var $8tHhR = parcelRequire("8tHhR");

var $8MyQj = parcelRequire("8MyQj");
const $2f431e60ef086510$export$e3a5d921ad306755 = ({ planId: planId, scenarioId: scenarioId, planTitle: planTitle, isReadOnly: isReadOnly, isArchived: isArchived, onPlanStatusUpdated: onPlanStatusUpdated })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const redirectToSpaPlanPage = (0, $4hkqI.useRedirectToSpaPlanPage)();
    const [modalState, setModalState] = (0, $5uXOq.useState)(undefined);
    const resetModalState = ()=>setModalState(undefined);
    const [onboarding, setOnboarding] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onPlanMenuButtonClicked = (0, $5uXOq.useCallback)(()=>{
        const planMenuButtonClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'planMenuButton'
        });
        (0, $8zOmE.fireUIAnalytics)(planMenuButtonClickAnalyticsEvent, (0, $6d15i.PLAN_MENU_ANALYTICS));
    }, [
        createAnalyticsEvent
    ]);
    const onHelpLinkClicked = (0, $5uXOq.useCallback)(()=>{
        const helpLinkMenuItemClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'helpLinkMenuItem'
        });
        (0, $8zOmE.fireUIAnalytics)(helpLinkMenuItemClickAnalyticsEvent, (0, $6d15i.PLAN_MENU_ANALYTICS));
    }, [
        createAnalyticsEvent
    ]);
    const onTakeTourClicked = (0, $5uXOq.useCallback)(()=>{
        const takeTourMenuItemClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'takeTourMenuItem'
        });
        (0, $8zOmE.fireUIAnalytics)(takeTourMenuItemClickAnalyticsEvent, (0, $6d15i.PLAN_MENU_ANALYTICS));
        redirectToSpaPlanPage('/timeline');
        setOnboarding(Math.random().toString(36).substring(2));
    }, [
        createAnalyticsEvent,
        redirectToSpaPlanPage
    ]);
    const onDuplicateClicked = (0, $5uXOq.useCallback)(()=>{
        setModalState((0, $fb357ca71d819bf0$export$257be95a51c84145));
        const duplicateMenuItemClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'duplicateModalMenuItem'
        });
        (0, $8zOmE.fireUIAnalytics)(duplicateMenuItemClickAnalyticsEvent, (0, $6d15i.PLAN_MENU_ANALYTICS));
    }, [
        createAnalyticsEvent
    ]);
    const onDeleteClicked = (0, $5uXOq.useCallback)(()=>{
        setModalState((0, $fb357ca71d819bf0$export$2b848a0670941e75));
        const deleteMenuItemClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'deleteModalMenuItem'
        });
        (0, $8zOmE.fireUIAnalytics)(deleteMenuItemClickAnalyticsEvent, (0, $6d15i.PLAN_MENU_ANALYTICS));
    }, [
        createAnalyticsEvent
    ]);
    const onArchiveRestoreClicked = (0, $5uXOq.useCallback)(()=>{
        setModalState((0, $fb357ca71d819bf0$export$a7c1ec142e70d69d));
        const getArchiveOrRestoreEvent = ()=>createAnalyticsEvent({
                action: 'clicked',
                actionSubject: isArchived ? 'restoreModalMenuItem' : 'archiveModalMenuItem'
            });
        (0, $8zOmE.fireUIAnalytics)(getArchiveOrRestoreEvent(), (0, $6d15i.PLAN_MENU_ANALYTICS));
    }, [
        createAnalyticsEvent,
        isArchived
    ]);
    const closeOnboarding = (0, $5uXOq.useCallback)((options)=>!options?.silent && setOnboarding(undefined), []); // Most plan operations aren't possible without a plan or scenario id, but we can still show *something*
    if (planId === undefined || scenarioId === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3w19c.default), {
        description: formatMessage((0, $ixnGT.default).plan)
    }, planTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3w19c.default), {
        description: formatMessage((0, $ixnGT.default).plan)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _19cnidpf _a86jidpf _1f8l1wug _tpmhidpf _1s3gidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-live": "polite",
        "aria-atomic": "true",
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _2hwx12x7"
        ])
    }, planTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        onOpenChange: ({ isOpen: isOpen })=>{
            if (isOpen) onPlanMenuButtonClicked();
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tHhR.default), null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))), {
                        label: "",
                        color: "currentColor"
                    }),
                ref: triggerRef,
                label: formatMessage((0, $ixnGT.default).triggerLabel)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                ...props,
                ref: triggerRef,
                "aria-label": formatMessage((0, $ixnGT.default).triggerLabel),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
                    spacing: "spacious",
                    label: ""
                }),
                spacing: "none",
                appearance: "subtle"
            })),
        placement: "bottom-end",
        shouldFlip: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: onHelpLinkClicked,
        href: (0, $fb357ca71d819bf0$export$60097003722957e7),
        target: "_blank",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            label: ""
        })
    }, formatMessage((0, $ixnGT.default).help)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: onTakeTourClicked
    }, formatMessage((0, $ixnGT.default).takeTour)), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: onDuplicateClicked
    }, formatMessage((0, $ixnGT.default).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: onDeleteClicked
    }, formatMessage((0, $ixnGT.default).trash)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: onArchiveRestoreClicked
    }, isArchived ? formatMessage((0, $ixnGT.default).restore) : formatMessage((0, $ixnGT.default).archive))))), modalState === (0, $fb357ca71d819bf0$export$257be95a51c84145) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $laDtS.DuplicatePlanModal), {
        planId: Number(planId),
        planTitle: planTitle,
        setClosed: resetModalState
    }), modalState === (0, $fb357ca71d819bf0$export$2b848a0670941e75) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8MyQj.TrashPlanModal), {
        planId: Number(planId),
        setClosed: resetModalState
    }), modalState === (0, $fb357ca71d819bf0$export$a7c1ec142e70d69d) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cLs0.ArchivePlanModal), {
        planId: Number(planId),
        scenarioId: Number(scenarioId),
        planTitle: planTitle,
        isArchived: isArchived,
        setClosed: resetModalState,
        onPlanStatusUpdated: onPlanStatusUpdated
    }), onboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pynQ.Onboarding), {
        visible: true,
        key: onboarding,
        onClose: closeOnboarding
    }));
};
$2f431e60ef086510$export$e3a5d921ad306755.defaultProps = {
    planId: undefined,
    scenarioId: undefined,
    isReadOnly: true
};
const $2f431e60ef086510$var$flexContainerStyles = null;
const $2f431e60ef086510$var$textOverflowStyles = null;

});
parcelRegister("7cLs0", function(module, exports) {

$parcel$export(module.exports, "ArchivePlanModal", () => $3da0936dcef6dec8$export$18a8da6e12f1ef88);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $9DMzk = parcelRequire("9DMzk");

var $lVJAU = parcelRequire("lVJAU");

var $4f9RS = parcelRequire("4f9RS");
const $3da0936dcef6dec8$export$18a8da6e12f1ef88 = ({ planId: planId, scenarioId: scenarioId, planTitle: planTitle, isArchived: isArchived, setClosed: setClosed, onPlanStatusUpdated: onPlanStatusUpdated })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onComplete = ()=>{
        onPlanStatusUpdated();
        const title = isArchived ? (0, $4f9RS.default).restored : (0, $4f9RS.default).archived;
        showFlag({
            title: title,
            type: 'success',
            isAutoDismiss: false,
            messageId: 'navigation-apps-sidebar-plan.ui.menu.header.archive-modal.show-flag.success',
            messageType: 'transactional'
        });
        push(`/jira/plans/${planId}/scenarios/${scenarioId}`);
    };
    const onError = ()=>{
        setClosed();
        const id = isArchived ? 'restorePlanError' : 'archivePlanError';
        const title = isArchived ? (0, $4f9RS.default).restoreError : (0, $4f9RS.default).archiveError;
        showFlag({
            id: id,
            title: title,
            type: 'error',
            messageId: 'navigation-apps-sidebar-plan.ui.menu.header.archive-modal.show-flag.error',
            messageType: 'transactional'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DMzk.default), {
        planId: planId,
        planTitle: planTitle,
        isArchived: isArchived,
        onClose: setClosed,
        onComplete: onComplete,
        onError: onError,
        fallback: null
    });
};

});
parcelRegister("4f9RS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7219673261682dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c7219673261682dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    archived: {
        "id": "navigation-apps-sidebar-plan.menu.header.archive-modal.archived",
        "defaultMessage": "Plan archived successfully"
    },
    restored: {
        "id": "navigation-apps-sidebar-plan.menu.header.archive-modal.restored",
        "defaultMessage": "Plan restored successfully"
    },
    archiveError: {
        "id": "navigation-apps-sidebar-plan.menu.header.archive-modal.archive-error",
        "defaultMessage": "We couldn't archive your plan. Try again."
    },
    restoreError: {
        "id": "navigation-apps-sidebar-plan.menu.header.archive-modal.restore-error",
        "defaultMessage": "We couldn't restore your plan. Try again."
    }
});

});


const $fb357ca71d819bf0$export$257be95a51c84145 = 'DUPLICATE';
const $fb357ca71d819bf0$export$a7c1ec142e70d69d = 'ARCHIVE';
const $fb357ca71d819bf0$export$2b848a0670941e75 = 'TRASH';
const $fb357ca71d819bf0$export$60097003722957e7 = 'https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/';

parcelRegister("laDtS", function(module, exports) {

$parcel$export(module.exports, "DuplicatePlanModal", () => $4c0e276d712c6aad$export$d87287bf306868bb);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $l5kCn = parcelRequire("l5kCn");

var $lVJAU = parcelRequire("lVJAU");

var $2kpAj = parcelRequire("2kpAj");
const $4c0e276d712c6aad$export$d87287bf306868bb = ({ planId: planId, planTitle: planTitle, setClosed: setClosed })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onComplete = (newPlanId, newScenarioId)=>{
        setClosed();
        push(`/jira/plans/${newPlanId}/scenarios/${newScenarioId}`);
    };
    const onError = ()=>{
        setClosed();
        showFlag({
            id: 'duplicatePlanError',
            type: 'error',
            title: (0, $2kpAj.default).error,
            messageId: 'navigation-apps-sidebar-plan.ui.menu.header.duplicate-modal.show-flag.error',
            messageType: 'transactional'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5kCn.default), {
        planId: planId,
        planTitle: planTitle,
        onClose: setClosed,
        onComplete: onComplete,
        onError: onError,
        fallback: null
    });
};

});
parcelRegister("2kpAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6304d37d614032$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f6304d37d614032$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "navigation-apps-sidebar-plan.menu.header.duplicate-modal.error",
        "defaultMessage": "We couldn't duplicate your plan. Try again."
    }
});

});


parcelRegister("ixnGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3ff6c269d8aabc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f3ff6c269d8aabc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plan: {
        "id": "navigation-apps-sidebar-plan.menu.header.plan",
        "defaultMessage": "Plan"
    },
    triggerLabel: {
        "id": "navigation-apps-sidebar-plan.menu.header.trigger-label",
        "defaultMessage": "Plan settings"
    },
    help: {
        "id": "navigation-apps-sidebar-plan.menu.header.help",
        "defaultMessage": "Get started with plans"
    },
    duplicate: {
        "id": "navigation-apps-sidebar-plan.menu.header.duplicate",
        "defaultMessage": "Duplicate plan"
    },
    trash: {
        "id": "navigation-apps-sidebar-plan.menu.header.trash",
        "defaultMessage": "Move to trash"
    },
    archive: {
        "id": "navigation-apps-sidebar-plan.menu.header.archive",
        "defaultMessage": "Archive"
    },
    restore: {
        "id": "navigation-apps-sidebar-plan.menu.header.restore",
        "defaultMessage": "Restore"
    },
    takeTour: {
        "id": "navigation-apps-sidebar-plan.menu.header.take-tour",
        "defaultMessage": "Take tour"
    }
});

});

parcelRegister("8tHhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86d226f4f62574b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $inni2 = parcelRequire("inni2");
var $cOGPo = parcelRequire("cOGPo");
var $Pxnvj = parcelRequire("Pxnvj");
var $98UVV = parcelRequire("98UVV");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $gPQRI = parcelRequire("gPQRI");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $ehdJY = parcelRequire("ehdJY");

var $lOmY2 = parcelRequire("lOmY2");
const $f86d226f4f62574b$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);
const $f86d226f4f62574b$var$TARGET = 'plan-settings-menu-trigger';
const $f86d226f4f62574b$var$MESSAGE_ID = 'ploverview-sidebar-menu';
const $f86d226f4f62574b$var$Nudge = ({ stop: stop, children: children })=>{
    const { isCollapsed: isLeftSideBarCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'planHeaderMenuSpotlightNudge dismissed');
        stop?.();
        setIsSpotlightActive(false);
    }, [
        stop
    ]);
    if (isLeftSideBarCollapsed || !isSpotlightActive) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "planHeaderMenuSpotlightNudge",
        sourceType: "Screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: $f86d226f4f62574b$var$TARGET
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOGPo.Pulse), {
        radius: 3
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onClick,
                text: formatMessage((0, $lOmY2.default).dismiss)
            }
        ],
        heading: formatMessage((0, $lOmY2.default).title),
        target: $f86d226f4f62574b$var$TARGET,
        key: $f86d226f4f62574b$var$TARGET,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageId: "navigation-apps-sidebar-plan.ui.menu.header.nudge.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $lOmY2.default).description)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $f86d226f4f62574b$var$NudgeProvider = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $f86d226f4f62574b$var$MESSAGE_ID,
        fallback: children,
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f86d226f4f62574b$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f86d226f4f62574b$var$Nudge, {
            stop: stop
        }, children)));
var $f86d226f4f62574b$export$2e2bcd8739ae039 = $f86d226f4f62574b$var$NudgeProvider;

});
parcelRegister("lOmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb38a6a762c13d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e1bb38a6a762c13d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-apps-sidebar-plan.menu.header.nudge.title",
        "defaultMessage": "A new menu for you"
    },
    description: {
        "id": "navigation-apps-sidebar-plan.menu.header.nudge.description",
        "defaultMessage": "We've moved the plan management options to this menu. Select this to do things like duplicate or archive your plan."
    },
    dismiss: {
        "id": "navigation-apps-sidebar-plan.menu.header.nudge.dismiss",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("8MyQj", function(module, exports) {

$parcel$export(module.exports, "TrashPlanModal", () => $cf48d222143292f7$export$904566914f982884);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $1UdpC = parcelRequire("1UdpC");

var $lVJAU = parcelRequire("lVJAU");

var $69UBi = parcelRequire("69UBi");
const $cf48d222143292f7$export$904566914f982884 = ({ planId: planId, setClosed: setClosed })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onComplete = ()=>{
        push('/jira/plans');
        setClosed();
    };
    const onError = ()=>{
        setClosed();
        showFlag({
            id: 'trashPlanError',
            type: 'error',
            title: (0, $69UBi.default).error,
            messageId: 'navigation-apps-sidebar-plan.ui.menu.header.trash-modal.show-flag.error',
            messageType: 'transactional'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UdpC.default), {
        planId: planId,
        onCancel: setClosed,
        onComplete: onComplete,
        onError: onError,
        fallback: null
    });
};

});
parcelRegister("69UBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb9d68f82f274b9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0fb9d68f82f274b9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "navigation-apps-sidebar-plan.menu.header.trash-modal.error",
        "defaultMessage": "We couldn't move your plan to the trash. Try again."
    }
});

});



parcelRegister("ehvm7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4cbba532eeadb1c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d4cbba532eeadb1c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plan: {
        "id": "navigation-apps-sidebar-plan.menu.plan",
        "defaultMessage": "Plan"
    },
    planning: {
        "id": "navigation-apps-sidebar-plan.menu.planning",
        "defaultMessage": "Planning"
    },
    summary: {
        "id": "navigation-apps-sidebar-plan.menu.summary",
        "defaultMessage": "Summary"
    },
    calendar: {
        "id": "navigation-apps-sidebar-plan.menu.calendar",
        "defaultMessage": "Calendar"
    },
    timeline: {
        "id": "navigation-apps-sidebar-plan.menu.timeline",
        "defaultMessage": "Timeline"
    },
    increments: {
        "id": "navigation-apps-sidebar-plan.menu.increments",
        "defaultMessage": "Program"
    },
    teams: {
        "id": "navigation-apps-sidebar-plan.menu.teams",
        "defaultMessage": "Teams"
    },
    releases: {
        "id": "navigation-apps-sidebar-plan.menu.releases",
        "defaultMessage": "Releases"
    },
    dependencies: {
        "id": "navigation-apps-sidebar-plan.menu.dependencies",
        "defaultMessage": "Dependencies"
    },
    planInfo: {
        "id": "navigation-apps-sidebar-plan.menu.plan-info",
        "defaultMessage": "Plan info"
    },
    features: {
        "id": "navigation-apps-sidebar-plan.menu.features",
        "defaultMessage": "Features"
    },
    backToPlan: {
        "id": "navigation-apps-sidebar-plan.menu.back-to-plan",
        "defaultMessage": "Back to plan"
    },
    planSettings: {
        "id": "navigation-apps-sidebar-plan.menu.plan-settings",
        "defaultMessage": "Plan settings"
    },
    general: {
        "id": "navigation-apps-sidebar-plan.menu.general",
        "defaultMessage": "General"
    },
    scheduling: {
        "id": "navigation-apps-sidebar-plan.menu.scheduling",
        "defaultMessage": "Scheduling"
    },
    savedViews: {
        "id": "navigation-apps-sidebar-plan.menu.saved-views",
        "defaultMessage": "Saved views"
    },
    programBoards: {
        "id": "navigation-apps-sidebar-plan.menu.program-boards",
        "defaultMessage": "Program boards"
    },
    sourceData: {
        "id": "navigation-apps-sidebar-plan.menu.source-data",
        "defaultMessage": "Source data"
    },
    issueSources: {
        "id": "navigation-apps-sidebar-plan.menu.issue-sources",
        "defaultMessage": "Issue sources"
    },
    exclusionRules: {
        "id": "navigation-apps-sidebar-plan.menu.exclusion-rules",
        "defaultMessage": "Exclusion rules"
    },
    removedIssues: {
        "id": "navigation-apps-sidebar-plan.menu.removed-issues",
        "defaultMessage": "Removed issues"
    },
    findYourIssue: {
        "id": "navigation-apps-sidebar-plan.menu.find-your-issue",
        "defaultMessage": "Find your issue"
    },
    customFields: {
        "id": "navigation-apps-sidebar-plan.menu.custom-fields",
        "defaultMessage": "Custom fields"
    },
    accessControl: {
        "id": "navigation-apps-sidebar-plan.menu.access-control",
        "defaultMessage": "Access control"
    },
    permissions: {
        "id": "navigation-apps-sidebar-plan.menu.permissions",
        "defaultMessage": "Permissions"
    },
    advanced: {
        "id": "navigation-apps-sidebar-plan.menu.advanced",
        "defaultMessage": "Advanced"
    },
    scenarios: {
        "id": "navigation-apps-sidebar-plan.menu.scenarios",
        "defaultMessage": "Scenarios"
    },
    autoScheduler: {
        "id": "navigation-apps-sidebar-plan.menu.auto-scheduler",
        "defaultMessage": "Auto-scheduler"
    },
    footerWhatArePlans: {
        "id": "navigation-apps-sidebar-plan.menu.footer-what-are-plans",
        "defaultMessage": "What are plans?"
    },
    earlyAccess: {
        "id": "navigation-apps-sidebar-plan.menu.early-access-no-translate",
        "defaultMessage": "Early access"
    },
    issueSourcesIssueTermRefresh: {
        "id": "navigation-apps-sidebar-plan.menu.issue-sources-issue-term-refresh",
        "defaultMessage": "Work item sources"
    },
    removedIssuesIssueTermRefresh: {
        "id": "navigation-apps-sidebar-plan.menu.removed-issues-issue-term-refresh",
        "defaultMessage": "Removed work items"
    },
    findYourIssueIssueTermRefresh: {
        "id": "navigation-apps-sidebar-plan.menu.find-your-issue-issue-term-refresh",
        "defaultMessage": "Find your work item"
    },
    newLozenge: {
        "id": "navigation-apps-sidebar-plan.menu.new-lozenge",
        "defaultMessage": "New"
    }
});

});

parcelRegister("3EYjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad5c4e4d238df22$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $1UEDB = parcelRequire("1UEDB");

var $fpoBX = parcelRequire("fpoBX");

var $doZTA = parcelRequire("doZTA");

var $cmHtH = parcelRequire("cmHtH");

var $hHYJY = parcelRequire("hHYJY");
function $6ad5c4e4d238df22$var$PlanningContainer({ submenuActive: submenuActive, children: children }) {
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { data: data } = (0, $1UEDB.usePlan)();
    const { params: { scenarioId: scenarioId } } = match;
    const matchingScenario = data?.scenarios.find(({ id: id })=>String(id) === scenarioId);
    if (scenarioId == null || !matchingScenario || !data || submenuActive) return null;
    const { color: color } = matchingScenario;
    const { isMultiScenarioEnabled: isMultiScenarioEnabled } = data;
    if (isMultiScenarioEnabled) {
        const theme = (0, $hHYJY.scenarioTheme)[color] ?? (0, $hHYJY.scenarioTheme).default;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpoBX.SidebarThemeProvider), {
            theme: {
                navigation: {
                    item: theme
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ad5c4e4d238df22$var$MultiScenario, {
            backgroundColor: theme.background.default
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmHtH.default), {
            planNavInfo: data,
            scenario: matchingScenario,
            outlineColor: theme.color.active
        }), children));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
var $6ad5c4e4d238df22$export$2e2bcd8739ae039 = $6ad5c4e4d238df22$var$PlanningContainer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ad5c4e4d238df22$var$MultiScenario = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bbod19": (0, $lD23V.default)(`${Math.round((0, $gwIPs.borderRadius) * 2.666)}px`),
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkownbd _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _otyr1b66 _bfhk3qkl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cmHtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fcc41aacf80a311$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $cNW3X = parcelRequire("cNW3X");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $dGKFs = parcelRequire("dGKFs");

var $gTpfq = parcelRequire("gTpfq");

var $koVbs = parcelRequire("koVbs");

var $gPQRI = parcelRequire("gPQRI");

var $2OMDV = parcelRequire("2OMDV");

var $9VXkC = parcelRequire("9VXkC");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $6d15i = parcelRequire("6d15i");

var $lNk4n = parcelRequire("lNk4n");
const $0fcc41aacf80a311$var$SIDEBAR_PADDING = 28;
const $0fcc41aacf80a311$export$1d16dd19bd2e4d57 = (0, $2OMDV.AnalyticsEventToProps)('dropMenuItem', {
    onClick: 'clicked'
})((0, $1eETS.default));
const $0fcc41aacf80a311$var$noPaddingStyles = null;
const $0fcc41aacf80a311$var$ScenarioSwitcher = ({ planNavInfo: planNavInfo, scenario: scenario, outlineColor: outlineColor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { width: width } = (0, $gPQRI.useLeftSidebarState)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { scenarios: scenarios } = planNavInfo;
    const { path: path, params: { planId: planId, incrementId: incrementId } } = match;
    const handleOnClick = (0, $5uXOq.useCallback)((scenarioId, nextPage)=>{
        const params = {
            planId: planId,
            scenarioId: scenarioId,
            incrementId: incrementId
        };
        const url = nextPage ? `${(0, $9VXkC.generatePath)((0, $6d15i.PLANS_BASE_PATH), params)}/${nextPage}` : (0, $9VXkC.generatePath)(path, params);
        push(url);
    }, [
        incrementId,
        path,
        planId,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$TriggerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                ...props,
                ref: triggerRef,
                shouldFitContainer: true,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$ScenarioTitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$ScenarioItemColor, {
                backgroundColor: scenario.color,
                borderColor: outlineColor
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$DropMenuItemText, null, scenario.title))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$DropdownItemGroup, {
        width: width - $0fcc41aacf80a311$var$SIDEBAR_PADDING,
        title: formatMessage((0, $lNk4n.default).header)
    }, scenarios.map(({ color: color, id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$export$1d16dd19bd2e4d57, {
            key: id,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$ScenarioItemColor, {
                backgroundColor: color
            }),
            id: id,
            isSelected: id === scenario.id,
            onClick: ()=>{
                handleOnClick(id);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$DropMenuItemText, null, title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$DropdownItemGroup, {
        width: width - $0fcc41aacf80a311$var$SIDEBAR_PADDING,
        hasSeparator: true // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & { width: number; } & SectionProps & RefAttributes<HTMLElement> & StyledProps'.ts(2322)
        ,
        className: (0, $bwpsq.default)([
            "_cfu1glyw _1ywuglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$export$1d16dd19bd2e4d57, {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTpfq))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>{
            handleOnClick(scenario.id, `${(0, $6d15i.SECTION_ID).SETTINGS}/scenarios`);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fcc41aacf80a311$var$DropMenuItemText, null, formatMessage((0, $lNk4n.default).manageScenarios)))));
};
var $0fcc41aacf80a311$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0fcc41aacf80a311$var$ScenarioSwitcher;
const $0fcc41aacf80a311$var$ScenarioItemColor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, borderColor: borderColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_1lp7z9w": (0, $lD23V.default)(__cmplp.borderColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3i7vkz _1bsb7vkz _1o9zidpf _bfhk3qkl",
            __cmplp.borderColor ? "_19it1h10" : "_19itglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fcc41aacf80a311$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_f7xt1ylp _1msb1txw _5jgi1h6o _1nlx18uv _yo3gfg4m _7mfv15ej _szlb16l4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fcc41aacf80a311$var$ScenarioTitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1yb1u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fcc41aacf80a311$var$DropdownItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3jAdT.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1hdq _1g7815vq _20i815vq _16rh1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fcc41aacf80a311$var$DropMenuItemText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gTpfq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c55e11080ecfc1$var$_react = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c4c55e11080ecfc1$var$_edit = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("084bx")));

var $c4c55e11080ecfc1$var$_edit2 = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("78GxT")));
function $c4c55e11080ecfc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c55e11080ecfc1$var$EditIcon = (props)=>/*#__PURE__*/ $c4c55e11080ecfc1$var$_react.default.createElement($c4c55e11080ecfc1$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $c4c55e11080ecfc1$var$_edit2.default
    }, props));
$c4c55e11080ecfc1$var$EditIcon.Name = 'EditIconMigration';
var $c4c55e11080ecfc1$var$_default = module.exports.default = $c4c55e11080ecfc1$var$EditIcon;

});
parcelRegister("78GxT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532a48721af78794$var$_react = $532a48721af78794$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $532a48721af78794$var$_edit = $532a48721af78794$var$_interopRequireDefault((parcelRequire("084bx")));
function $532a48721af78794$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532a48721af78794$var$EditIcon = (props)=>/*#__PURE__*/ $532a48721af78794$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $532a48721af78794$var$_edit.default
    }));
$532a48721af78794$var$EditIcon.displayName = 'EditIcon';
var $532a48721af78794$var$_default = module.exports.default = $532a48721af78794$var$EditIcon;

});


parcelRegister("lNk4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e20461b8c459d1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2e20461b8c459d1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "navigation-apps-sidebar-plan.menu.planning-container.scenario-switcher.header",
        "defaultMessage": "Scenarios"
    },
    manageScenarios: {
        "id": "navigation-apps-sidebar-plan.menu.planning-container.scenario-switcher.manage-scenarios",
        "defaultMessage": "Manage scenarios"
    }
});

});


parcelRegister("hHYJY", function(module, exports) {

$parcel$export(module.exports, "scenarioTheme", () => $35b1dbb85b3f1c1f$export$27e807ad95d96389);

const $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8 = (bgcolor, activeBgcolor, activeColor)=>({
        background: {
            default: bgcolor,
            active: activeBgcolor,
            hover: activeBgcolor
        },
        color: {
            active: activeColor
        }
    });
const $35b1dbb85b3f1c1f$export$27e807ad95d96389 = {
    // Light Yellow
    [(0, $a7f8c6b391092279$exports).Y100]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-yellow-subtlest, #FFF7D6)", "var(--ds-background-accent-yellow-subtler, #F8E6A0)", "var(--ds-background-accent-yellow-bolder, #946F00)"),
    // Orange
    [(0, $a7f8c6b391092279$exports).Y400]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-orange-subtlest, #FFF3EB)", "var(--ds-background-accent-orange-subtler, #FEDEC8)", "var(--ds-background-accent-orange-bolder, #C25100)"),
    // Light teal
    [(0, $a7f8c6b391092279$exports).T100]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-teal-subtlest, #E7F9FF)", "var(--ds-background-accent-teal-subtler, #C6EDFB)", "var(--ds-background-accent-teal-bolder, #227D9B)"),
    // Teal
    [(0, $a7f8c6b391092279$exports).T400]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-teal-subtlest, #E7F9FF)", "var(--ds-background-accent-teal-subtler, #C6EDFB)", "var(--ds-background-accent-teal-bolder, #227D9B)"),
    // Light purple
    [(0, $a7f8c6b391092279$exports).P75]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-purple-subtlest, #F3F0FF)", "var(--ds-background-accent-purple-subtler, #DFD8FD)", "var(--ds-background-accent-purple-bolder, #6E5DC6)"),
    // Purple
    [(0, $a7f8c6b391092279$exports).P400]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-purple-subtlest, #F3F0FF)", "var(--ds-background-accent-purple-subtler, #DFD8FD)", "var(--ds-background-accent-purple-bolder, #6E5DC6)"),
    // Light blue
    [(0, $a7f8c6b391092279$exports).B100]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-blue-subtlest, #E9F2FF)", "var(--ds-background-accent-blue-subtler, #CCE0FF)", "var(--ds-background-accent-blue-bolder, #0C66E4)"),
    // Blue
    [(0, $a7f8c6b391092279$exports).B400]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-blue-subtlest, #E9F2FF)", "var(--ds-background-accent-blue-subtler, #CCE0FF)", "var(--ds-background-accent-blue-bolder, #0C66E4)"),
    // Light green
    [(0, $a7f8c6b391092279$exports).G100]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-green-subtlest, #DCFFF1)", "var(--ds-background-accent-green-subtler, #BAF3DB)", "var(--ds-background-accent-green-bolder, #1F845A)"),
    // Green
    [(0, $a7f8c6b391092279$exports).G400]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-green-subtlest, #DCFFF1)", "var(--ds-background-accent-green-subtler, #BAF3DB)", "var(--ds-background-accent-green-bolder, #1F845A)"),
    // Light red
    [(0, $a7f8c6b391092279$exports).R100]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-red-subtlest, #FFECEB)", "var(--ds-background-accent-red-subtler, #FFD5D2)", "var(--ds-background-accent-red-bolder, #C9372C)"),
    // Red
    [(0, $a7f8c6b391092279$exports).R400]: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-red-subtlest, #FFECEB)", "var(--ds-background-accent-red-subtler, #FFD5D2)", "var(--ds-background-accent-red-bolder, #C9372C)"),
    // Fallback for when nothing matches
    default: $35b1dbb85b3f1c1f$export$eb0ab34b33d69cc8("var(--ds-background-accent-gray-subtlest, #F1F2F4)", "var(--ds-background-accent-gray-subtler, #DCDFE4)", "var(--ds-background-neutral-subtle-pressed, #091E4224)")
};

});


parcelRegister("acFnr", function(module, exports) {

$parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", () => $dd9684f4672640dd$export$5d06510124eb14f8);
$parcel$export(module.exports, "useStack", () => $dd9684f4672640dd$export$df58951aab233134);
$parcel$export(module.exports, "useNestedAppOpen", () => $dd9684f4672640dd$export$42ed85de1c100980);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $doZTA = parcelRequire("doZTA");

var $6d15i = parcelRequire("6d15i");
const $dd9684f4672640dd$export$5d06510124eb14f8 = ()=>(0, $6s1PB.expValEquals)('second_premium_template_experiment', 'cohort', 'variation');
const $dd9684f4672640dd$export$df58951aab233134 = ()=>{
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const stackFromRouteName = (0, $5uXOq.useMemo)(()=>{
        if (route.name.startsWith('plan-settings')) return [
            (0, $6d15i.SECTION_ID).SETTINGS
        ];
        return [];
    }, [
        route.name
    ]);
    const [stack, setStack] = (0, $5uXOq.useState)(stackFromRouteName);
    (0, $5uXOq.useEffect)(()=>{
        setStack(stackFromRouteName);
    }, [
        stackFromRouteName
    ]);
    return [
        stack,
        setStack
    ];
};
const $dd9684f4672640dd$export$42ed85de1c100980 = ()=>{
    const [stack] = $dd9684f4672640dd$export$df58951aab233134();
    const [value, setValue] = (0, $5uXOq.useState)(stack.length > 0);
    (0, $5uXOq.useEffect)(()=>{
        setValue(stack.length > 0);
    }, [
        stack
    ]);
    return [
        value,
        setValue
    ];
};

});


parcelRegister("9grVM", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $af9b6b2d0175cfac$export$93d4e7f90805808f);

var $5uXOq = parcelRequire("5uXOq");

var $1UEDB = parcelRequire("1UEDB");
const $af9b6b2d0175cfac$var$menuItemActiveHoverColor = "var(--ds-background-selected, #E9F2FF)";
const $af9b6b2d0175cfac$var$getTheme = (activeColor)=>({
        navigation: {
            item: {
                background: {
                    default: 'transparent',
                    active: $af9b6b2d0175cfac$var$menuItemActiveHoverColor,
                    hover: $af9b6b2d0175cfac$var$menuItemActiveHoverColor
                },
                color: {
                    active: activeColor
                }
            }
        }
    });
const $af9b6b2d0175cfac$export$93d4e7f90805808f = ()=>{
    const { data: data } = (0, $1UEDB.usePlan)();
    const isMultiScenarioEnabled = data?.isMultiScenarioEnabled;
    const theme = (0, $5uXOq.useMemo)(()=>{
        if (isMultiScenarioEnabled == null) return undefined;
        return $af9b6b2d0175cfac$var$getTheme("var(--ds-text-selected, #0C66E4)");
    }, [
        isMultiScenarioEnabled
    ]);
    return theme;
};

});




//# sourceMappingURL=async-sidebar-plan.2729bb36.js.map
